import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { MatDialog, MatDialogConfig } from '@angular/material';
import { environment } from '../../environments/environment';

import { MatSnackBar } from "@angular/material";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

import { ActividadService } from '../services/actividad.service';
import { Actividad } from '../models/actividad';
@Component({
  selector: 'app-actividad-editor',
  templateUrl: './actividad-editor.component.html',
  styleUrls: ['./actividad-editor.component.css']
})
export class ActividadEditorComponent implements OnInit {


  model: Actividad = new Actividad();
  modelPrev: Actividad = new Actividad();

  imagen = "./assets/avatar.png";

  model_id;

  upload: boolean = false;
  selectedFile: File = null;

  Url = environment.imgUrl;
  loading: boolean = false;

  tipos;
  secciones;

  constructor(private modelService: ActividadService, public dialog: MatDialog, private dialogRef: MatDialogRef<ActividadEditorComponent>, @Inject(MAT_DIALOG_DATA) data, private snackBar: MatSnackBar) {
    this.model_id = data.id;

    if (data.id != 0) {
      this.get(data.id);
      this.getPrev(data.id);
    }

  }

  ngOnInit() {
  }

  change(a, b) {
    let equal = true;
    for (let [key, val] of Object.entries(a)) {
      if (b[key] !== val) {
        equal = false;
      }
      else {
        equal = true;
      }

      if (!equal) { break; }

    }

    return equal;
  }


  close() {
    if (!this.change(this.modelPrev, this.model)) {


      const dialogConfig = new MatDialogConfig();

      dialogConfig.width = '390px';
      dialogConfig.data = {
        texto: 'Existen cambios sin guardar ¿Desea salir?'
      };
      const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(
        data => {
          if (data == true) {
            this.dialogRef.close();
          }
        }
      );
    }
    else {
      this.dialogRef.close();
    }
  }


  save() {
    this.loading = true;
    if (this.imagen == "./assets/avatar.png" || this.imagen == "./assets/avatar.png") {
      this.snackBar.open('Seleccione una Imagen', '', {
        duration: 3000,
        panelClass: ['red-snackbar']
      });
      this.loading = false;

    }
    else {
      if (this.model.id == null || this.model.id == 0 || this.model.id == undefined) {

        this.modelService.add(this.model).subscribe(
          val => {
            if (this.upload) {
              this.onUploadFile(val.id);
            }
            else {
              this.loading = false;
              this.snackBar.open('Registro Guardado', '', {
                duration: 2000,
              });
              this.dialogRef.close(val.id);
            }

          },
          error => {
            console.log(<any>error);
            this.snackBar.open('Intente de nuevo, ocurrio un error', '', {
              duration: 3000,
              panelClass: ['red-snackbar']
            });
            this.loading = false;
          });
      }
      else {

        this.modelService.edit(this.model).subscribe(
          val => {
            if (this.upload) {
              this.onUploadFile(val.id);
            }
            else {
              this.loading = false;
              this.snackBar.open('Registro Guardado', '', {
                duration: 2000,
              });

              this.dialogRef.close(val.id);

            }
          },
          error => {
            console.log(<any>error);
            this.snackBar.open('Intente de nuevo, ocurrio un error', '', {
              duration: 3000,
              panelClass: ['red-snackbar']
            });
            this.loading = false;
          });

      }

    }

  }

  get(id) {
    this.modelService.get(id).subscribe(
      val => {
        this.model = val;

        if (this.model.imagen == null)
          this.imagen = "./assets/avatar.png";
        else
          this.imagen = this.Url + this.model.imagen;

      },
      error => {
        console.log(<any>error);
      });

  }
  getPrev(id) {
    this.modelService.get(id).subscribe(
      val => {
        this.modelPrev = val;
      },
      error => {
        console.log(<any>error);
      });

  }

  onFileChange(event) {

    this.selectedFile = <File>event.target.files[0];
    this.upload = true;

    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imagen = event.target.result;
    }
    reader.readAsDataURL(event.target.files[0]);
    this.model.imagen = 'new';

  }

  onUploadFile(id) {

    const data = new FormData();
    data.append('imagen', this.selectedFile, this.selectedFile.name);

    this.modelService.changeImagePrincipal(data, id).subscribe(
      val => {
        this.loading = false;
        this.snackBar.open('Registro Guardado', '', {
          duration: 2000,
        });

        this.dialogRef.close();

      });
  }



}
